/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Showcase_Nodatatitle2Inputs */

const id_profile_showcase_nodatatitle2 = /** @type {(inputs: Profile_Showcase_Nodatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada data etalase`)
};

const ms_profile_showcase_nodatatitle2 = /** @type {(inputs: Profile_Showcase_Nodatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada data pameran`)
};

const da_profile_showcase_nodatatitle2 = /** @type {(inputs: Profile_Showcase_Nodatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen showcase-data endnu`)
};

const de_profile_showcase_nodatatitle2 = /** @type {(inputs: Profile_Showcase_Nodatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Vitrinen-Daten`)
};

const en_us2_profile_showcase_nodatatitle2 = /** @type {(inputs: Profile_Showcase_Nodatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No showcase data yet`)
};

const es_es2_profile_showcase_nodatatitle2 = /** @type {(inputs: Profile_Showcase_Nodatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay datos de vitrina`)
};

const es_mx2_profile_showcase_nodatatitle2 = /** @type {(inputs: Profile_Showcase_Nodatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay datos de vitrina`)
};

const fil_profile_showcase_nodatatitle2 = /** @type {(inputs: Profile_Showcase_Nodatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala pang data ng showcase`)
};

const fr_profile_showcase_nodatatitle2 = /** @type {(inputs: Profile_Showcase_Nodatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas encore de données de vitrine`)
};

const it_profile_showcase_nodatatitle2 = /** @type {(inputs: Profile_Showcase_Nodatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora nessun dato in vetrina`)
};

const hu_profile_showcase_nodatatitle2 = /** @type {(inputs: Profile_Showcase_Nodatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Még nincs kirakat adat`)
};

const nl_profile_showcase_nodatatitle2 = /** @type {(inputs: Profile_Showcase_Nodatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen vitrinegegevens`)
};

const no_profile_showcase_nodatatitle2 = /** @type {(inputs: Profile_Showcase_Nodatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen utstillingsdata ennå`)
};

const pl_profile_showcase_nodatatitle2 = /** @type {(inputs: Profile_Showcase_Nodatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak danych do prezentacji`)
};

const pt_br2_profile_showcase_nodatatitle2 = /** @type {(inputs: Profile_Showcase_Nodatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda não há dados de demonstração`)
};

const pt_profile_showcase_nodatatitle2 = /** @type {(inputs: Profile_Showcase_Nodatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda sem dados na vitrine`)
};

const ro_profile_showcase_nodatatitle2 = /** @type {(inputs: Profile_Showcase_Nodatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Încă nu există date în vitrină`)
};

const fi_profile_showcase_nodatatitle2 = /** @type {(inputs: Profile_Showcase_Nodatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei vielä esittelytietoja`)
};

const sv_profile_showcase_nodatatitle2 = /** @type {(inputs: Profile_Showcase_Nodatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga skyltfönsterdata än`)
};

const vi_profile_showcase_nodatatitle2 = /** @type {(inputs: Profile_Showcase_Nodatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có dữ liệu trưng bày`)
};

const tr_profile_showcase_nodatatitle2 = /** @type {(inputs: Profile_Showcase_Nodatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Henüz vitrin verisi yok`)
};

const cs_profile_showcase_nodatatitle2 = /** @type {(inputs: Profile_Showcase_Nodatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím žádná data ve vitríně`)
};

const bg_profile_showcase_nodatatitle2 = /** @type {(inputs: Profile_Showcase_Nodatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все още няма данни за витрина`)
};

const ru_profile_showcase_nodatatitle2 = /** @type {(inputs: Profile_Showcase_Nodatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Данные витрины пока отсутствуют`)
};

const uk_profile_showcase_nodatatitle2 = /** @type {(inputs: Profile_Showcase_Nodatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Даних вітрини ще немає`)
};

const ar_profile_showcase_nodatatitle2 = /** @type {(inputs: Profile_Showcase_Nodatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد بيانات عرض بعد`)
};

const hi_profile_showcase_nodatatitle2 = /** @type {(inputs: Profile_Showcase_Nodatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अभी तक कोई शोकेस डेटा नहीं`)
};

const th_profile_showcase_nodatatitle2 = /** @type {(inputs: Profile_Showcase_Nodatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยังไม่มีข้อมูลโชว์เคส`)
};

const ja_profile_showcase_nodatatitle2 = /** @type {(inputs: Profile_Showcase_Nodatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだショーケースデータがありません`)
};

const zh_cn2_profile_showcase_nodatatitle2 = /** @type {(inputs: Profile_Showcase_Nodatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无展示柜数据`)
};

const zh_hant1_profile_showcase_nodatatitle2 = /** @type {(inputs: Profile_Showcase_Nodatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暫無展示櫃資料`)
};

const ko_profile_showcase_nodatatitle2 = /** @type {(inputs: Profile_Showcase_Nodatatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`쇼케이스 데이터가 아직 없습니다`)
};

/**
* | output |
* | --- |
* | "No showcase data yet" |
*
* @param {Profile_Showcase_Nodatatitle2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_showcase_nodatatitle2 = /** @type {((inputs?: Profile_Showcase_Nodatatitle2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Showcase_Nodatatitle2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_showcase_nodatatitle2(inputs)
	if (locale === "ms") return ms_profile_showcase_nodatatitle2(inputs)
	if (locale === "da") return da_profile_showcase_nodatatitle2(inputs)
	if (locale === "de") return de_profile_showcase_nodatatitle2(inputs)
	if (locale === "en-US") return en_us2_profile_showcase_nodatatitle2(inputs)
	if (locale === "es-ES") return es_es2_profile_showcase_nodatatitle2(inputs)
	if (locale === "es-MX") return es_mx2_profile_showcase_nodatatitle2(inputs)
	if (locale === "fil") return fil_profile_showcase_nodatatitle2(inputs)
	if (locale === "fr") return fr_profile_showcase_nodatatitle2(inputs)
	if (locale === "it") return it_profile_showcase_nodatatitle2(inputs)
	if (locale === "hu") return hu_profile_showcase_nodatatitle2(inputs)
	if (locale === "nl") return nl_profile_showcase_nodatatitle2(inputs)
	if (locale === "no") return no_profile_showcase_nodatatitle2(inputs)
	if (locale === "pl") return pl_profile_showcase_nodatatitle2(inputs)
	if (locale === "pt-BR") return pt_br2_profile_showcase_nodatatitle2(inputs)
	if (locale === "pt") return pt_profile_showcase_nodatatitle2(inputs)
	if (locale === "ro") return ro_profile_showcase_nodatatitle2(inputs)
	if (locale === "fi") return fi_profile_showcase_nodatatitle2(inputs)
	if (locale === "sv") return sv_profile_showcase_nodatatitle2(inputs)
	if (locale === "vi") return vi_profile_showcase_nodatatitle2(inputs)
	if (locale === "tr") return tr_profile_showcase_nodatatitle2(inputs)
	if (locale === "cs") return cs_profile_showcase_nodatatitle2(inputs)
	if (locale === "bg") return bg_profile_showcase_nodatatitle2(inputs)
	if (locale === "ru") return ru_profile_showcase_nodatatitle2(inputs)
	if (locale === "uk") return uk_profile_showcase_nodatatitle2(inputs)
	if (locale === "ar") return ar_profile_showcase_nodatatitle2(inputs)
	if (locale === "hi") return hi_profile_showcase_nodatatitle2(inputs)
	if (locale === "th") return th_profile_showcase_nodatatitle2(inputs)
	if (locale === "ja") return ja_profile_showcase_nodatatitle2(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_showcase_nodatatitle2(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_showcase_nodatatitle2(inputs)
	return ko_profile_showcase_nodatatitle2(inputs)
});
export { profile_showcase_nodatatitle2 as "profile.showcase.noDataTitle" }